import React from 'react';
import { CreditCard } from 'lucide-react';
export const PaymentBadges: React.FC = () => {
  return <div className="flex flex-col items-center justify-center space-y-2 mt-4" data-id="element-250">
      <p className="text-xs text-gray-500 font-medium uppercase tracking-wider" data-id="element-251">
        Pagos 100% Seguros
      </p>
      <div className="flex items-center space-x-3 text-gray-400" data-id="element-252">
        <div className="flex items-center justify-center bg-gray-50 border border-gray-200 rounded px-3 py-1.5" data-id="element-253">
          <span className="text-sm font-bold text-blue-800 italic" data-id="element-254">VISA</span>
        </div>
        <div className="flex items-center justify-center bg-gray-50 border border-gray-200 rounded px-3 py-1.5" data-id="element-255">
          <div className="flex -space-x-2" data-id="element-256">
            <div className="w-4 h-4 rounded-full bg-red-500 mix-blend-multiply" data-id="element-257"></div>
            <div className="w-4 h-4 rounded-full bg-yellow-500 mix-blend-multiply" data-id="element-258"></div>
          </div>
          <span className="text-xs font-bold text-gray-800 ml-1" data-id="element-259">
            mastercard
          </span>
        </div>
        <div className="flex items-center justify-center bg-gray-50 border border-gray-200 rounded px-3 py-1.5" data-id="element-260">
          <span className="text-sm font-bold text-blue-500" data-id="element-261">Mercado Pago</span>
        </div>
      </div>
    </div>;
};